// extracted by mini-css-extract-plugin
export default {"rewardsSwitcherContainer":"RewardsSwitcher_rewardsSwitcherContainer__3ZDuG","rewardsSwitcher":"RewardsSwitcher_rewardsSwitcher__5KGXn"};